<template>
  <div class="home">
    <a-row class="top">
      <a-col class="left" :span="15">
        <div class="left-item1">客户至上、诚实守信、团队协作、拼搏进取、精益创新</div>
        <div class="left-item2">
          <div class="item-house">
            <h3 class="name">房源</h3>
            <p>您有<span class="big">3</span>个房源即将进入公盘，<a href="">去跟进</a></p>
          </div>
          <div class="item-house">
            <h3 class="name">客源</h3>
            <p>您有<span class="big">3</span>个房源即将进入公盘，<a href="">去跟进</a></p>
          </div>
        </div>
        <div class="left-item3">
          <h3 style="margin-left: 10px; margin-top: 10px; font-size: 18px">工作进度</h3>
          <div id="myChart" :style="{ width: '90%', height: '300px' }"></div>
        </div>
      </a-col>
      <a-col class="right" :span="8">
        <div class="right-item1">
          <a-avatar :size="64" icon="user" />
          <h3 style="font-weight: 700; margin-top: 40px">ACE战队·王锦晖</h3>
          <p>B店长-B6</p>
        </div>
        <div class="right-item2">
          <div class="rank-top">
            <span class="rankName">业绩排行</span>
            <a-dropdown>
              <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">本月 <a-icon type="down" /> </a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a href="javascript:;">本周</a>
                </a-menu-item>
                <a-menu-item>
                  <a href="javascript:;">本月</a>
                </a-menu-item>
                <a-menu-item>
                  <a href="javascript:;">本年</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
          <div class="rank-middle">
            <div class="name-item">
              <a-avatar :size="64" icon="user" />
              <h4>陆店长</h4>
              <p>90100</p>
            </div>
            <div class="name-item">
              <a-avatar :size="64" icon="user" />
              <h4>陆店长1</h4>
              <p>90100</p>
            </div>
            <div class="name-item">
              <a-avatar :size="64" icon="user" />
              <h4>陆店长2</h4>
              <p>90100</p>
            </div>
          </div>
        </div>
        <a-row class="right-item3">
          <a-col class="one" :span="5">
            <a-avatar :size="64" icon="user" />
          </a-col>
          <a-col class="two" :span="6"
            ><h4 style="font-size: 20px; font-weight: 700">我</h4>
            <div>12,100</div>
            <span>当前排名：30</span></a-col
          >
          <a-col class="three" :span="10"
            ><a-tooltip placement="right" defaultVisible="true">
              <template slot="title">
                <span>还差1900就能超过我了，加油呀</span>
              </template>
              <a-avatar :size="32" icon="user" /> </a-tooltip
          ></a-col>
        </a-row>
      </a-col>
    </a-row>
    <div class="study">
      <h3>学习</h3>
      <div class="content">
        <div class="item" v-for="v in 4" :key="v">
          <img class="img" src="./111.png" />
          <p style="margin-top: 10px; font-size: 18px">
            <span style="font-weight: 700; margin-right: 10px">这是一个标题</span>
            <a-tag color="pink"> 经验 </a-tag>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    drawLine() {
      this.chart = this.$echarts.init(document.querySelector('#myChart'))

      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // Use axis to trigger tooltip
            type: 'shadow', // 'shadow' as default; can also be 'line' or 'shadow'
          },
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: false,
        },
        xAxis: {
          type: 'value',
        },
        yAxis: {
          type: 'category',
          data: ['钥匙', '面访', '带看', '客增', '房增', '房源跟进', '客源跟进'],
        },
        series: [
          {
            // name: 'Direct',
            type: 'bar',
            stack: 'total',
            label: {
              show: true,
            },
            emphasis: {
              focus: 'series',
            },
            data: [32, 30, 31, 34, 90, 30, 30],
          },
          {
            // name: 'Search Engine',
            type: 'bar',
            stack: 'total',
            label: {
              show: true,
            },
            emphasis: {
              focus: 'series',
            },
            data: [50, 32, 41, 64, 50, 30, 20],
          },
        ],
      }

      this.chart.setOption(option)
    },
  },
  mounted() {
    this.drawLine()
  },
}
</script>

<style lang="less" scoped>
.home {
  .top {
    display: flex;
    justify-content: space-between;
    .left {
      .left-item1 {
        border: 1px solid #ccc;
        height: 100px;
        border-radius: 6px;
        font-size: 18px;
        color: #000;
        text-align: center;
        line-height: 100px;
      }
      .left-item2 {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
        .item-house {
          padding: 10px 0 0 20px;
          width: 49%;
          border: 1px solid #ccc;
          color: #000;
          .name {
            font-size: 18px;
            color: #000;
          }
          .big {
            font-weight: 700;
            font-size: 26px;
          }
        }
      }
      .left-item3 {
        margin-top: 15px;
        height: 443px;
        border: 1px solid #ccc;
      }
    }
    .right {
      .right-item1 {
        border: 1px solid #ccc;
        text-align: center;
        padding-top: 40px;
        color: #000;
        height: 300px;
      }
      .right-item2 {
        margin-top: 15px;
        border: 1px solid #ccc;
        height: 216px;
        .rank-top {
          padding: 15px;
          color: #000;
          .rankName {
            font-size: 20px;
            margin-right: 15px;
          }
        }
        .rank-middle {
          padding: 15px;
          display: flex;
          justify-content: space-between;
          color: #000;
          .name-item {
            text-align: center;
            h4 {
              font-weight: 700;
              margin-top: 15px;
            }
          }
        }
      }
      .right-item3 {
        border: 1px solid #ccc;
        border-top: none;
        color: #000;
        padding: 15px;
        .one {
          margin-top: 20px;
        }
        .two {
          margin-top: 30px;
        }
        .three {
          margin-top: 50px;
        }
      }
    }
  }
  .study {
    margin-top: 20px;
    padding: 0 16px;
    color: #000;
    h3 {
      font-size: 20px;
    }
    .content {
      display: flex;
      width: 100%;
      .item {
        width: 25%;
        .img {
          width: 95%;
        }
      }
    }
  }
}
</style>